import React from 'react';
import PropTypes from 'prop-types';
import { useLocales } from '@/locales';
import { User, UserX } from 'lucide-react';
import { cn } from '@/lib/utils';

const CertificateList = ({
  certificates = [],
  selectedIndex,
  onCertificateSelect,
  isKeyFound = false,
}) => {
  const { translate } = useLocales();

  const dateParser = date => {
    const exactDate = new Date(date);
    const actualDate = `${exactDate.getFullYear()}-${
      exactDate.getMonth() + 1
    }-${exactDate.getDate()}`;
    return actualDate;
  };

  if (!certificates.length) {
    return null;
  }

  const handleKeyDown = (e, certificate, index) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onCertificateSelect(certificate, index);
    }
  };

  return (
    <div className="space-y-2">
      {certificates.map((certificate, index) => (
        <div
          key={index}
          role="button"
          tabIndex={0}
          className={cn(
            'flex items-center gap-3 p-4 rounded-lg border cursor-pointer transition-colors',
            'hover:bg-accent focus:outline-none focus:ring-2 focus:ring-ring',
            index === selectedIndex && 'border-primary bg-primary/5',
          )}
          onClick={() => onCertificateSelect(certificate, index)}
          onKeyDown={e => handleKeyDown(e, certificate, index)}
        >
          {isKeyFound ? (
            <User className="h-8 w-8 text-primary" />
          ) : (
            <UserX className="h-8 w-8 text-muted-foreground" />
          )}
          <div className="flex-1 min-w-0">
            <p className="font-medium truncate">{certificate.CN}</p>
            <p className="text-sm text-muted-foreground">
              {translate('Certificate_validity_period')}:{' '}
              {dateParser(certificate.validTo)}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

CertificateList.propTypes = {
  certificates: PropTypes.arrayOf(
    PropTypes.shape({
      CN: PropTypes.string,
      validTo: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
      ]),
    }),
  ),
  selectedIndex: PropTypes.number,
  onCertificateSelect: PropTypes.func.isRequired,
  isKeyFound: PropTypes.bool,
};

export default CertificateList;
